import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import SUSPICIOUS_ACTIVITY_IMG from '../../assets/img/proctor-suspicious-activity-flagged.svg';
import {
  REALTIME_FEEDBACK_LIST,
  REALTIME_FEEDBACK_MODAL_DESCRIPTION,
  REALTIME_FEEDBACK_MODAL_TITLE,
} from './constant';
import {
  WebcamNotDetected as SuspiciousActivityDetected,
  WebcamNotDetectedMoreItems as SuspiciousActivityMoreItems,
  ToggleMore,
  Bolder,
} from '../Proctor/Proctor.style';
import { popUpClick, popUpView } from '../../utils/trackingUtil';
import { POPUP_NAME } from '../../constants/Constants';
import { renderTemplate } from '../../utils/stringUtils';

export default function RealTimeFeedbackModal({
  showModal,
  setShowModal,
  productType,
}) {
  const [toggleMore, setToggleMore] = useState(false);
  const productTypeUpper = productType?.toUpperCase();

  useEffect(() => {
    if (showModal) {
      popUpView({
        payload: {
          popUpTitle: POPUP_NAME.realTimeFeedback,
          popUpAction: 'real time feedback modal triggered',
        },
      });
    }
  }, [showModal]);

  const handleProceedToTest = () => {
    setShowModal(false);
    popUpClick({
      payload: {
        popUpTitle: POPUP_NAME.realTimeFeedback,
        popUpAction: 'Real time feedback modal triggered',
        label: 'PROCEED TO TEST',
      },
    });
  };

  const handleToggleMore = () => {
    setToggleMore(!toggleMore);
  };

  return (
    <Modal backdrop="static" centered size="lg" isOpen={showModal}>
      <ModalBody>
        <SuspiciousActivityDetected
          src={SUSPICIOUS_ACTIVITY_IMG}
          className="d-block mx-auto"
        />
        <div className="d-flex justify-content-center">
          <h3>{REALTIME_FEEDBACK_MODAL_TITLE}</h3>
        </div>
        <p className="mt-2">
          {renderTemplate(REALTIME_FEEDBACK_MODAL_DESCRIPTION, {
            productTypeUpper,
          })}{' '}
          &nbsp;
          <ToggleMore
            className="text-primary cursor-pointer "
            onClick={handleToggleMore}
          >
            {toggleMore ? 'Show less' : 'Show more'}
          </ToggleMore>
        </p>
        {toggleMore && (
          <SuspiciousActivityMoreItems>
            {REALTIME_FEEDBACK_LIST.map(list => (
              <>
                - {list} <br />
              </>
            ))}
          </SuspiciousActivityMoreItems>
        )}
      </ModalBody>
      <ModalFooter className="d-flex flex-column justify-content-center">
        <div className="d-flex justify-content-center">
          <p>
            If the webcam feed is not visible,
            <Bolder>&nbsp;try refreshing the page.</Bolder>
          </p>
        </div>
        <button
          type="button"
          onClick={handleProceedToTest}
          className="btn btn-primary"
        >
          <i className="fa fa-play mr-2" />
          PROCEED TO {productTypeUpper}
        </button>
      </ModalFooter>
    </Modal>
  );
}
